import React, { useEffect } from 'react';
import { ApolloProvider } from '@apollo/client';
import { config as fontAwesomeConfig } from '@fortawesome/fontawesome-svg-core';

import { handleAdvertisingClick } from 'wheelspin/dist/utils/analyticsUtils';
import DeviceContext, { defaultDeviceContext } from 'wheelspin/dist/context/DeviceContext';
import { getUserAgentResult } from 'wheelspin/dist/utils/deviceUtils';
import isServer from 'wheelspin/dist/utils/isServer';
import Footer from 'wheelspin/dist/components/Footer';

import { apolloClient } from './utils/apolloClient';
import HeaderContainer from './containers/HeaderContainer';

// Global CSS
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'wheelspin/dist/styles/index.scss';

fontAwesomeConfig.autoAddCss = false;

const bindFooterJavaScript = () => {
  document.addEventListener('click', (event) => {
    if ((event.target as HTMLButtonElement).dataset.typeId === 'advertizing-preferences') {
      handleAdvertisingClick();
    }
  });
};

const rootElement = document.getElementById('__next');
const isBeforeStaticSnapshot = !rootElement?.hasChildNodes();

const App: React.FunctionComponent = () => {
  useEffect(() => {
    bindFooterJavaScript();
  }, []);

  const userAgentResult = !isServer
    ? getUserAgentResult(window.navigator.userAgent)
    : defaultDeviceContext;

  return (
    <ApolloProvider client={apolloClient}>
      <DeviceContext.Provider value={userAgentResult}>
        <HeaderContainer displayUserStatus={!isBeforeStaticSnapshot} />
        {isBeforeStaticSnapshot && <Footer />}
      </DeviceContext.Provider>
    </ApolloProvider>
  );
};

export default App;
